import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconUserRoundFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <circle
      cx={12}
      cy={7}
      r={3}
      fill="currentColor"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
    />
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
      d="M4 19.053a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6V20H4v-.947Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const Memo = memo(SvgIconUserRoundFill);
export default Memo;
